import React, { useEffect } from 'react';

export const useRegisterCloseRequest = (
  closeRequestRef: React.MutableRefObject<(() => void) | null> | undefined,
  onCloseRequest: () => void,
) => {
  useEffect(() => {
    if (!closeRequestRef) {
      return;
    }

    closeRequestRef.current = onCloseRequest;

    return () => {
      closeRequestRef.current = null;
    };
  }, [closeRequestRef, onCloseRequest]);
};

export default useRegisterCloseRequest;
